__turbopack_context__.v({
  "backButton": "CFilesToDownload-module__6vrydq__backButton",
  "badge": "CFilesToDownload-module__6vrydq__badge",
  "badgeWarn": "CFilesToDownload-module__6vrydq__badgeWarn",
  "description": "CFilesToDownload-module__6vrydq__description",
  "empty": "CFilesToDownload-module__6vrydq__empty",
  "fileBody": "CFilesToDownload-module__6vrydq__fileBody",
  "fileIcon": "CFilesToDownload-module__6vrydq__fileIcon",
  "fileLink": "CFilesToDownload-module__6vrydq__fileLink",
  "fileMeta": "CFilesToDownload-module__6vrydq__fileMeta",
  "fileName": "CFilesToDownload-module__6vrydq__fileName",
  "fileSize": "CFilesToDownload-module__6vrydq__fileSize",
  "filter": "CFilesToDownload-module__6vrydq__filter",
  "list": "CFilesToDownload-module__6vrydq__list",
  "row": "CFilesToDownload-module__6vrydq__row",
  "select": "CFilesToDownload-module__6vrydq__select",
  "srOnly": "CFilesToDownload-module__6vrydq__srOnly",
  "topBar": "CFilesToDownload-module__6vrydq__topBar",
  "wrap": "CFilesToDownload-module__6vrydq__wrap",
});
